import React, { useEffect, useState, useRef } from 'react'
import { Table, Modal, Spin, Button, Input, Switch } from 'antd';
import { sendNotify } from '../helper/notification'
import HomeRep from '../repository/homeRep'
import { API_BASE_URL } from '../helper'

export default function Leadership() {
  const imageUploader = useRef();
  const videoUploader = useRef();

  const { confirm } = Modal;
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState([])
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [author, setAuthor] = useState('')
  const [position, setPosition] = useState('')
  const [videoUrl, setVideoUrl] = useState('')
  
  const [showVideoUpload, setShowVideoUpload] = useState(false)
  const [showThumbnailUpload, setShowThumbnailUpload] = useState(false)

  const [formData, setFormData] = useState({})
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mode, setMode] = useState('Add')
  const [imageFiles, setImageFiles] = useState([]);
  const [videoFiles, setVideoFiles] = useState([]);

  useEffect(() => {
    getLeadershipData()
  }, []);

  const columns = [
    {
      title: 'S.No',
      dataIndex: 'key',
    },
    {
      title: 'Thumbnail',
      dataIndex: 'media',
      render: (_, record) => {
        const { image_url } = record;
        if (!image_url) return <div className="text-muted small">No Image</div>;
        const src = image_url?.startsWith('/') ? `${API_BASE_URL || ''}${image_url}` : image_url;

        return (
          <img
            src={src}
            alt=""
            width="80"
            height="80"
            className='img-fluid'
            style={{ objectFit: 'cover', borderRadius: '8px' }}
          />
        );
      },
    },
    {
      title: 'Title',
      dataIndex: 'title'
    },
    {
      title: 'Author',
      dataIndex: 'author'
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      render: (_, record) => (
        <div className='d-flex'>
          <button className='btn' onClick={() => openModal(record, "Edit")}>
            <i className="far fa-edit fa-lg" style={{ color: "#0083ff" }}></i>
          </button>
          <button className='btn' onClick={() => confrimDelete(record._id)}>
            <i className="fas fa-trash fa-lg" style={{ color: "#ff0000" }}></i>
          </button>
        </div>
      ),
    },
  ];

  const getLeadershipData = () => {
    setLoading(true)
    HomeRep.getLeadership().then(response => {
      setLoading(false)
      if (response) {
        if (response?.error || response.status_code !== 200) {
          sendNotify('error', response.message || 'Failed to fetch Data');
          setList([]);
        } else {
          let data = response?.data?.map((item, i) => ({
            key: i + 1,
            ...item
          }));
          setList(data);
        }
      }
    }).catch(error => {
      sendNotify('error', 'Failed to fetch Data');
      setLoading(false);
    });
  }
  
  const openModal = (data, mode) => {
    setMode(mode);
    if (mode === "Edit" && data) {
      setTitle(data.title || '');
      setDescription(data.description || '');
      setAuthor(data.author || '');
      setPosition(data.position || '');
      setVideoUrl(data.video_url || '');
      
      setShowVideoUpload(data.video_url?.startsWith('/uploads/') ? true : false);
      setShowThumbnailUpload(data.image_url ? true : false);

      if (data.image_url) {
        const imgSrc = data.image_url?.startsWith('/') ? `${API_BASE_URL || ''}${data.image_url}` : data.image_url;
        setImageFiles([{ name: "Existing Thumbnail", url: imgSrc }]);
      } else {
        setImageFiles([]);
      }
      
      if (data.video_url && data.video_url.startsWith('/uploads/')) {
         setVideoFiles([{ name: "Existing Video", url: `${API_BASE_URL || ''}${data.video_url}` }]);
      } else {
         setVideoFiles([]);
      }

      setFormData(data);
    } else {
      setTitle('');
      setDescription('');
      setAuthor('');
      setPosition('');
      setVideoUrl('');
      setShowVideoUpload(false);
      setShowThumbnailUpload(false);
      setImageFiles([]);
      setVideoFiles([]);
      setFormData({});
    }
    setIsModalOpen(true);
  };

  const onImageUpload = async (e) => {
    let files = Array.from(e.target.files);
    if (files.length === 0) return;
    let file = files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setImageFiles([{ file: file, base64: reader.result, name: file.name }]);
    };
  };

  const onVideoUpload = async (e) => {
    let files = Array.from(e.target.files);
    if (files.length === 0) return;
    let file = files[0];
    setVideoFiles([{ file: file, name: file.name }]);
  };

  const handleOk = async () => {
    if (!title || !author || !position) {
      sendNotify('error', 'Please fill all required fields (Title, Author, Position)');
      return;
    }

    // Word count validation for description
    if (description) {
      const words = description.trim().split(/\s+/);
      if (words.length > 20) {
        sendNotify('error', 'Description cannot exceed 20 words');
        return;
      }
    }

    const payload = new FormData();
    payload.append('title', title);
    payload.append('description', description || '');
    payload.append('author', author);
    payload.append('position', position);
    payload.append('mediaType', 'video');
    
    // Always use videoUrl from state if it's there and we're not uploading a custom file
    if (!showVideoUpload && videoUrl) {
      payload.append('video_url', videoUrl);
    }

    if (mode === 'Edit') {
      payload.append('id', formData._id);
      // If we're not uploading a NEW image but have an existing one, keep it
      if (!showThumbnailUpload && formData.image_url) {
        payload.append('image_url', formData.image_url);
      }
      // If we're not uploading a NEW video and not using a NEW URL, but have an existing URL/path
      if (!showVideoUpload && !videoUrl && formData.video_url) {
        payload.append('video_url', formData.video_url);
      }
    }

    if (showThumbnailUpload && imageFiles[0]?.file) {
      payload.append('image', imageFiles[0].file);
    }

    if (showVideoUpload && videoFiles[0]?.file) {
      payload.append('video', videoFiles[0].file);
    }

    HomeRep.addLeadership(payload)
      .then((response) => {
        if (response?.error || response.status_code !== 200) {
          sendNotify('error', response.message || 'An unknown error occurred');
        } else {
          setIsModalOpen(false);
          getLeadershipData();
          sendNotify('success', response.message || 'Leadership entry saved successfully');
          setImageFiles([]);
          setVideoFiles([]);
        }
      })
      .catch((error) => {
        sendNotify('error', 'Failed to update leadership item.');
      });
  };

  const confrimDelete = (id) => {
    confirm({
      title: <h5>Confirm Delete</h5>,
      content: <p>Are you sure you want Delete?</p>,
      className: 'custom-confirm',
      centered: true,
      okText: 'Delete',
      onOk() {
        deleteRecord(id);
      },
    });
  };

  const deleteRecord = (id) => {
    setLoading(true)
    HomeRep.deleteLeadership(id).then(response => {
      if (response) {
        if (response?.error || response.status_code !== 200) {
          sendNotify('error', response.message || 'Failed to delete data')
          setLoading(false)
        } else {
          sendNotify('success', 'Deleted successfully')
          getLeadershipData()
        }
      }
    }).catch(error => {
      sendNotify('error', 'An error occurred during deletion')
      setLoading(false)
    })
  }

  return (
    <section className='mt-md-3'>
      <div className="page-header flex-md-row flex-column">
        <h1>Leadership</h1>
        <button className="primary-btn" onClick={() => openModal(null, "Add")}><i className="fas fa-plus"></i> Add Leadership</button>
      </div>

      <Table columns={columns} dataSource={list} loading={loading} pagination={{ className: 'custom-pagination' }} className='custom-table' />
      
      <Modal 
          title={mode === 'Add' ? 'Add Leadership' : 'Edit Leadership'} 
          className='custom-modal' 
          open={isModalOpen} 
          onCancel={() => setIsModalOpen(false)}
          width={700}
          footer={[
              <Button key="cancel" onClick={() => setIsModalOpen(false)}>Cancel</Button>,
              <Button key="ok" type="primary" onClick={handleOk}>OK</Button>
          ]}
      >
        <Spin spinning={false}>
          <div className='input-box mb-4'>
            <label>Video URL (YouTube/Vimeo/etc.)</label>
            <div className='input-field'>
              <Input
                type="text"
                value={videoUrl}
                placeholder="https://www.youtube.com/watch?v=..."
                onChange={(e) => setVideoUrl(e.target.value)}
                disabled={showVideoUpload}
              />
            </div>
          </div>

          <div className='row mb-4'>
             <div className='col-md-6 d-flex align-items-center gap-2'>
                <Switch checked={showVideoUpload} onChange={(checked) => setShowVideoUpload(checked)} />
                <label>Upload Custom Video File</label>
             </div>
             <div className='col-md-6 d-flex align-items-center gap-2'>
                <Switch checked={showThumbnailUpload} onChange={(checked) => setShowThumbnailUpload(checked)} />
                <label>Upload Thumbnail/Image</label>
             </div>
          </div>

          <div className='row'>
            {showVideoUpload && (
              <div className='col-md-6 mb-4'>
                <label className='mb-2 small font-weight-bold'>Video File</label>
                <div 
                  className="custom-dragger p-0 w-100" 
                  style={{ border: '2px dashed #0083ff', borderRadius: '16px', textAlign: 'center', cursor: 'pointer', minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f7ff' }}
                  onClick={() => videoUploader.current.click()}
                >
                  <input type="file" accept="video/*" ref={videoUploader} onChange={onVideoUpload} className="d-none" />
                  {videoFiles.length > 0 ? (
                    <div className="p-2">
                      <i className="fas fa-video fa-2x mb-2" style={{color: '#0083ff'}}></i>
                      <p className='mb-0 text-truncate' style={{fontSize: '12px'}}>{videoFiles[0].name}</p>
                    </div>
                  ) : (
                    <div style={{ color: '#888', fontSize: '13px' }}>Click to upload Video</div>
                  )}
                </div>
              </div>
            )}

            {showThumbnailUpload && (
              <div className='col-md-6 mb-4'>
                <label className='mb-2 small font-weight-bold'>Thumbnail/Image</label>
                <div 
                  className="custom-dragger p-0 w-100" 
                  style={{ border: '2px dashed #0083ff', borderRadius: '16px', textAlign: 'center', cursor: 'pointer', minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f7ff' }}
                  onClick={() => imageUploader.current.click()}
                >
                  <input type="file" accept="image/*" ref={imageUploader} onChange={onImageUpload} className="d-none" />
                  {imageFiles.length > 0 ? (
                    <div className="p-2">
                      <img src={imageFiles[0].base64 || imageFiles[0].url} alt="Thumbnail" width="60" height="60" style={{ objectFit: 'cover', borderRadius: '8px' }} />
                      <p className='mt-2 mb-0 text-truncate' style={{fontSize: '12px'}}>{imageFiles[0].name}</p>
                    </div>
                  ) : (
                    <div style={{ color: '#888', fontSize: '13px' }}>Click to upload Thumbnail</div>
                  )}
                </div>
              </div>
            )}
          </div>

          <hr className='my-2' />

          <div className='input-box req mt-4'>
            <label>Title <span style={{color: 'red'}}>*</span></label>
            <div className='input-field'>
              <Input
                type="text"
                value={title}
                placeholder="Leadership Episode Name"
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
          </div>

          <div className='row'>
            <div className='col-md-6'>
              <div className='input-box req mt-4'>
                <label>Author <span style={{color: 'red'}}>*</span></label>
                <div className='input-field'>
                  <Input
                    type="text"
                    value={author}
                    placeholder="e.g. John Doe"
                    onChange={(e) => setAuthor(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className='col-md-6'>
              <div className='input-box req mt-4'>
                <label>Position <span style={{color: 'red'}}>*</span></label>
                <div className='input-field'>
                  <Input
                    type="text"
                    value={position}
                    placeholder="e.g. CEO, Bayada Healthcare"
                    onChange={(e) => setPosition(e.target.value)}
                  />
                </div>
              </div>
              </div>
          </div>

          <div className='input-box mt-4'>
            <label>Description</label>
            <div className='input-field'>
              <Input.TextArea
                rows={4}
                value={description}
                placeholder="Enter description here... (Max 20 words)"
                onChange={(e) => setDescription(e.target.value)}
              />
              <div className='text-end mt-1' style={{ fontSize: '12px', color: (description.trim().split(/\s+/).filter(w => w !== '').length > 20) ? 'red' : '#888' }}>
                {description.trim() === '' ? 0 : description.trim().split(/\s+/).filter(w => w !== '').length} / 20 words
              </div>
            </div>
          </div>
        </Spin>
      </Modal>
    </section>
  )
}
